import { ExclamationCircleFilled } from "@ant-design/icons"
import { type Expense } from "@finway-group/shared/lib/models"
import { formatCurrencyNumber, toDinero } from "@finway-group/shared/lib/utils"
import { Alert } from "antd"
import React from "react"
import { Trans, useTranslation } from "react-i18next"

export const AutoGeneratedExpenseAmountBanner = ({ expense }: { expense: Expense }) => {
    const { t } = useTranslation()

    const transactionRawContent = expense.metadata?.bannerDataForAutoGeneratedExpenseAmountMismatch?.transactionRawContent
    const isValidMatchedTransactions = expense.metadata?.bannerDataForAutoGeneratedExpenseAmountMismatch?.isValidMatchedTransactions
    const isTransactionSourceAmountMismatch =
        transactionRawContent?.sourceAmount && !toDinero(Math.abs(transactionRawContent.sourceAmount)).equalsTo(toDinero(Math.abs(expense.totalGrossPrice)))

    const shouldShowBanner = expense.isAutoGenerated && expense.card && isTransactionSourceAmountMismatch && isValidMatchedTransactions

    if (!shouldShowBanner) {
        return null
    }

    return (
        <Alert
            showIcon
            type="error"
            icon={<ExclamationCircleFilled />}
            message={
                <>
                    <Trans
                        t={t}
                        i18nKey="info:auto_generated_request_gross_amount_mismatch"
                        values={{
                            transactionAmount: formatCurrencyNumber({
                                value: Math.abs(transactionRawContent?.sourceAmount || 0) as number,
                                currency: expense.currency,
                            }),
                        }}
                    />
                </>
            }
        />
    )
}
